import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import {
  FaDownload,
  FaFileAlt,
  FaFileImage,
  FaFileVideo,
  FaRegFilePdf,
  FaSearch,
  FaTimes,
} from "react-icons/fa";
import { TiThMenu } from "react-icons/ti";
import OrderDetail from "./OrderDetail";
import { useLocation, useNavigate } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../Files/BaseURL";
import axios from "axios";
import SocketContext from "../../../../Context/Socket/SocketContext";
import { formatDateForInput } from "../../../../Files/UseFunction";
import { BsFiletypeDocx } from "react-icons/bs";
import { MdFolderZip } from "react-icons/md";
import ThemeContext from "../../../../Context/theme/ThemeContext";

const scrollbarHideStyles = `
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
`;

const MainChat = () => {
  const { theme } = useContext(ThemeContext);
  const [OrderStatus, setOrderStatus] = useState(false);
  const [UserData, setUserData] = useState(null);
  const [Conversation, setConversation] = useState([]);
  const [TotalPages, setTotalPages] = useState(null);
  const [Page, setPage] = useState(null);
  const [Chats, setChats] = useState([]);
  const [message, setmessage] = useState("");
  const [ChatFile, setChatFile] = useState(null);
  const [FileName, setFileName] = useState(null);
  const [UploadedFile, setUploadedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const scrollContainerRef = useRef(null);

  const location = useLocation();
  const navigate = useNavigate();

  const alertcontext = useContext(AlertContext);
  const { showAlert } = alertcontext;

  const socketcontext = useContext(SocketContext);
  const { OnlineUsers, SocetConnection, isUserOnline } = socketcontext;
  const [offer, setOffer] = useState(null);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSendMessage(e);
    }
  };

  const fetchOffer = async () => {
    try {
      const queryParams = new URLSearchParams(location.search);
      const user = queryParams.get("user");
      const response = await axios.get(
        `${BaseURL}/api/getoffer/getLatestOffer/${user}`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": localStorage.getItem("p@token"),
          },
        }
      );
      if (response.status === 200) {
        setOffer(response.data);
      }
    } catch (error) {
      console.error("Error fetching offer info:", error);
    }
  };
  const fetchuser = async (id) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/getusers/getuser/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": authToken,
          },
        }
      );
      if (response.data.success) {
        setUserData(response.data.user);
      } else {
        showAlert(response.data.message, "danger");
      }
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  const fetchconversation = async (id) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/messaging/getMessages/${id}?page=1`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": authToken,
          },
        }
      );
      if (response.data.success) {
        setConversation(response.data.messages);
        setTotalPages(response.data.totalPages);
        setPage(response.data.page);
      } else {
        showAlert(response.data.message, "danger");
      }
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  const fetchchats = async (id) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/messaging/AllConversation`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": authToken,
          },
        }
      );
      if (response.data.success) {
        setChats(response.data.conversations);
      } else {
        showAlert(response.data.message, "danger");
      }
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  const updateSeenChat = async (id) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/messaging/markAsSeen/${id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": authToken,
          },
        }
      );
      if (response.ok) {
        fetchchats();
      }
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  const loadMoreMessages = useCallback(
    async (chatId, pageNumber) => {
      if (isLoading || pageNumber > TotalPages) return;

      try {
        setIsLoading(true);
        const scrollContainer = scrollContainerRef.current;
        const previousHeight = scrollContainer?.scrollHeight || 0;

        const authToken = localStorage.getItem("p@token");
        const response = await axios.get(
          `${BaseURL}/api/messaging/getMessages/${chatId}?page=${pageNumber}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "auth-token": authToken,
            },
          }
        );

        if (response.data.success) {
          setConversation((prevMessages) => [
            ...response.data.messages,
            ...prevMessages,
          ]);
          setTotalPages(response.data.totalPages);
          setPage(response.data.page);

          setTimeout(() => {
            if (scrollContainer) {
              const newHeight = scrollContainer.scrollHeight;
              scrollContainer.scrollTop = newHeight - previousHeight;
            }
          }, 0);
        } else {
          showAlert(response.data.message, "danger");
        }
      } catch (error) {
        showAlert(error.message, "danger");
      } finally {
        setIsLoading(false);
      }
    },
    [isLoading, TotalPages, showAlert]
  );

  const handleScroll = useCallback(
    (e) => {
      const container = e.target;
      if (container.scrollTop <= 100 && !isLoading) {
        const queryParams = new URLSearchParams(location.search);
        const chatid = queryParams.get("chatid");

        if (chatid && Page < TotalPages) {
          loadMoreMessages(chatid, Page + 1);
        }
      }
    },
    [Page, TotalPages, isLoading, loadMoreMessages, location.search]
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const userid = queryParams.get("user");
    const chatid = queryParams.get("chatid");

    if (userid !== null) {
      fetchuser(userid);
    } else {
      setUserData(null);
    }
    if (chatid !== null) {
      fetchconversation(chatid);
      updateSeenChat(chatid);
      fetchchats();
      fetchOffer();
    } else {
      console.log(90);
      setConversation([]);
      setPage(1);
      setTotalPages(null);
    }
  }, [location.search]);

  useEffect(() => {
    fetchchats();
  }, []);

  useEffect(() => {
    if (SocetConnection) {
      const handleMessage = (data) => {
        const queryParams = new URLSearchParams(location.search);
        const chatid = queryParams.get("chatid");
        const userid = queryParams.get("user");

        // Ensure chatid and data.Chat_id are strings for comparison
        const normalizedChatId = chatid ? chatid.trim() : "";
        const normalizedDataChatId = data.Chat_id ? data.Chat_id.trim() : "";

        if (normalizedChatId && normalizedDataChatId) {
          if (normalizedChatId === normalizedDataChatId) {
            fetchconversation(chatid);
            updateSeenChat(chatid);
            fetchchats();
          } else {
            console.log(1233);
            fetchchats();
          }
        } else {
          console.log(12334);
          fetchchats();
        }
      };

      // Attach the event handler
      SocetConnection.on("message", handleMessage);

      // Cleanup function to remove the event handler
      return () => {
        SocetConnection.off("message", handleMessage);
      };
    }
  }, [SocetConnection, location.search]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    const queryParams = new URLSearchParams(location.search);
    const userid = queryParams.get("user");

    if (userid) {
      if (message !== "") {
        if (SocetConnection) {
          SocetConnection.emit("new message", {
            UserID: userid,
            covnersation: message,
            File: {
              Link: UploadedFile,
              Name: FileName,
            },
          });
          setmessage("");
          setUploadedFile(null);
          setFileName(null);
          setChatFile(null);
        }
      }
    }
  };

  const FileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      setChatFile(file);
      setFileName(file.name);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("filename", file.name);

      const authToken = localStorage.getItem("p@token");
      const response = await fetch(`${BaseURL}/api/messaging/upload-docs`, {
        method: "POST",
        headers: {
          "auth-token": authToken,
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setUploadedFile(data?.location);
      } else {
        showAlert("File not uploaded, try again", "danger");
      }
    } catch (error) {
      console.error("File upload error:", error);
      showAlert("File not uploaded, try again", "danger");
    }
  };

  const renderFileIcon = (file) => {
    const fileType = file;

    switch (fileType) {
      case "image":
        return <FaFileImage className="text-2xl w-full text-primarygreen" />;
      case "video":
        return <FaFileVideo className="text-2xl w-full text-primarygreen" />;
      case "pdf":
        return <FaRegFilePdf className="text-2xl w-full text-red-500" />;
      case "application":
        return <FaRegFilePdf className="text-2xl w-full text-red-500" />;
      case "doc":
        return <BsFiletypeDocx className="text-2xl w-full text-blue-500" />;
      case "docx":
        return <BsFiletypeDocx className="text-2xl w-full text-blue-500" />;
      case "zip":
        return <MdFolderZip className="text-2xl w-full text-gray-400" />;
      default:
        return <FaFileAlt className="text-2xl w-full text-primarygreen" />;
    }
  };

  return (
    <>
      <style>{scrollbarHideStyles}</style>
      {OrderStatus && (
        <OrderDetail setOrderStatus={setOrderStatus} offer={offer} />
      )}
      <div className="min-h-full overflow-hidden">
        {UserData !== null && (
          <div
            className={` font-pop w-full px-2 md:px-6  ${
              theme == "dark" ? "bg-black text-white" : "bg-white "
            }`}
          >
            <div className="lg:flex hidden flex-row md:flex-row justify-between md:items-center">
              <div className="flex flex-row gap-2 items-center">
                {UserData?.ProfilePhoto ? (
                  <img
                    src={UserData?.ProfilePhoto}
                    alt=""
                    className="rounded-full w-8 md:w-12 h-8 md:h-12"
                  />
                ) : (
                  <div
                    className={`w-8 md:w-12 h-8 md:h-12 rounded-full font-pop  flex items-center justify-center
                                ${
                                  theme == "dark"
                                    ? "bg-black text-white"
                                    : "bg-gray-400 "
                                }`}
                  >
                    <span className="text-white">
                      {UserData?.FirstName && UserData?.FirstName?.charAt(0)}
                    </span>
                  </div>
                )}
                <div
                  className={`flex flex-col  ${
                    theme == "dark" ? "bg-black text-white" : "bg-white "
                  }`}
                >
                  <h2 className="text-sm md:text-lg font-semibold">
                    {UserData?.FirstName} {UserData?.LastName}
                  </h2>
                  <p
                    className={`text-xs md:text-base text-gray-400
                                ${
                                  theme == "dark"
                                    ? "bg-black text-white"
                                    : "bg-white "
                                }`}
                  >
                    Last connect 8 hours ago
                  </p>
                </div>
              </div>
              {offer && (
                <div className="hidden lg:flex flex-row gap-2 items-center">
                  <TiThMenu
                    className="text-xl block"
                    onClick={() => {
                      setOrderStatus(true);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        )}

        <div
          className={`flex flex-row ${
            UserData ? "min-h-[calc(100vh-150px)]" : "min-h-[calc(100vh-100px)]"
          }`}
        >
          <div
            className={`lg:basis-[30%] w-[100%] h-[100vh] lg:h-auto  relative flex flex-col gap-6 py-4 px-6 font-pop  ${
              theme == "dark" ? "bg-black text-white" : "bg-white "
            } `}
          >
            <div
              className={`flex gap-3 items-center  rounded-full py-1 px-4  ${
                theme == "dark" ? "bg-black text-white" : "bg-gray-200 "
              }`}
            >
              <FaSearch
                className={` text-gray-400 text-lg md:text-2xl
                            ${theme == "dark" && "bg-black text-white"}`}
              />
              <input
                type="text"
                placeholder="Search..."
                className="bg-transparent text-sm md:text-lg border-none outline-none focus:outline-none focus:border-none active:outline-none "
              />
            </div>
            <div className="lg:flex hidden flex-col gap-2">
              {Chats?.map((item, index) => (
                <div
                  className={`border-2 ${
                    item?.chat?.other_user_details?._id == UserData?._id
                      ? "border-primarygreen bg-primarygreen/30"
                      : "border-[#E9E9E9] bg-white"
                  }  py-2 px-4 rounded-2xl`}
                  onClick={() => {
                    navigate(
                      `/user-dashboard/chat?user=${item?.chat?.other_user_details?._id}&chatid=${item?.chat?._id}`
                    );
                  }}
                >
                  <div className="flex flex-row justify-between items-center">
                    <div className="flex flex-row gap-2">
                      {item?.chat?.other_user_details?.ProfilePhoto ? (
                        <img
                          src={item?.chat?.other_user_details?.ProfilePhoto}
                          alt=""
                          className="rounded-full w-8 md:w-12 h-8 md:h-12"
                        />
                      ) : (
                        <div className="w-8 md:w-12 h-8 md:h-12 rounded-full font-pop bg-gray-400 flex items-center justify-center">
                          <span className="text-white">
                            {item?.chat?.other_user_details?.FirstName &&
                              item?.chat?.other_user_details?.FirstName?.charAt(
                                0
                              )}
                          </span>
                        </div>
                      )}
                      <div className="flex flex-col gap-0">
                        <h2 className="font-medium text-lg">
                          {item?.chat?.other_user_details?.FirstName}{" "}
                          {item?.chat?.other_user_details?.LastName}
                        </h2>
                        <p
                          className={`${
                            isUserOnline(item?.chat?.other_user_details?._id)
                              ? "text-primarygreen"
                              : "text-lightGrey"
                          }`}
                        >
                          {isUserOnline(item?.chat?.other_user_details?._id)
                            ? "Online"
                            : "Offline"}
                        </p>
                      </div>
                    </div>
                    {item.unseenCount >= 1 && (
                      <div className="bg-primarygreen w-8 text-center flex flex-col justify-center items-center h-8  rounded-full text-white font-pop">
                        <h2>{item.unseenCount}</h2>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="flex lg:hidden flex-col gap-2">
              {Chats?.map((item, index) => (
                <div
                  className="bg-white border-2 border-[#E9E9E9] py-2 px-4 rounded-2xl"
                  onClick={() => {
                    navigate(
                      `/user-dashboard/chat-detail?user=${item?.chat?.other_user_details?._id}&chatid=${item?.chat?._id}`
                    );
                  }}
                >
                  <div className="flex flex-row justify-between items-center">
                    <div className="flex flex-row gap-2">
                      {item?.chat?.other_user_details?.ProfilePhoto ? (
                        <img
                          src={item?.chat?.other_user_details?.ProfilePhoto}
                          alt=""
                          className="rounded-full w-8 md:w-12 h-8 md:h-12"
                        />
                      ) : (
                        <div className="w-8 md:w-12 h-8 md:h-12 rounded-full font-pop bg-gray-400 flex items-center justify-center">
                          <span className="text-white">
                            {item?.chat?.other_user_details?.FirstName &&
                              item?.chat?.other_user_details?.FirstName?.charAt(
                                0
                              )}
                          </span>
                        </div>
                      )}
                      <div className="flex flex-col gap-0">
                        <h2 className="font-medium text-lg">
                          {item?.chat?.other_user_details?.FirstName}{" "}
                          {item?.chat?.other_user_details?.LastName}
                        </h2>
                        <p
                          className={`${
                            isUserOnline(item?.chat?.other_user_details?._id)
                              ? "text-primarygreen"
                              : "text-lightGrey"
                          }`}
                        >
                          {isUserOnline(item?.chat?.other_user_details?._id)
                            ? "Online"
                            : "Offline"}
                        </p>
                      </div>
                    </div>
                    {item.unseenCount >= 1 && (
                      <div className="bg-primarygreen w-8 text-center flex flex-col justify-center items-center h-8  rounded-full text-white font-pop">
                        <h2>{item.unseenCount}</h2>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:basis-[70%] hidden lg:block font-pop px-6 py-4 overflow-x-hidden">
            {UserData && (
              <div className="flex flex-col gap-6 h-[100%] justify-between max-w-full">
                <div
                  className="flex flex-col gap-2 h-[calc(100vh-250px)] overflow-y-auto scrollbar-hide overflow-x-hidden"
                  ref={scrollContainerRef}
                  onScroll={handleScroll}
                  style={{
                    msOverflowStyle: "none",
                    scrollbarWidth: "none",
                  }}
                >
                  {isLoading && (
                    <div className="text-center py-2">
                      <p>Loading previous messages...</p>
                    </div>
                  )}
                  <div className="flex flex-col gap-2">
                    {Conversation?.length > 0 &&
                      Conversation?.map((item, index) => (
                        <div
                          className={`${
                            item.tag == "Sender"
                              ? "flex flex-col justify-end items-end"
                              : "flex flex-col justify-start items-start"
                          } my-1 gap-1 w-full`}
                        >
                          {item?.File?.Link && (
                            <div
                              className={` p-2 rounded w-fit shadow-md font-pop flex items-end ${
                                item.tag == "Sender"
                                  ? "bg-primarygreen/50 self-end text-white"
                                  : "bg-gray-300"
                              }`}
                            >
                              <div className="flex flex-col gap-2">
                                {item?.File && renderFileIcon(item?.File?.Link)}
                                <span className="ml-2">{item?.File?.Name}</span>
                              </div>
                              <a
                                href={item?.File?.Link}
                                download={true}
                                target="_blank"
                              >
                                <FaDownload className="ml-2 text-3xl text-gray-500 cursor-pointer" />
                              </a>
                            </div>
                          )}
                          <div
                            className={`${
                              item.tag == "Sender"
                                ? "bg-primarygreen text-white"
                                : "bg-[#E8E8E8]"
                            } rounded-xl py-2 px-4  md:max-w-[75%] lg:max-w-[65%] max-w-[60%] lg:break-all `}
                          >
                            <p className="text-sm md:text-base whitespace-pre-wrap break-words overflow-hidden">
                              {item?.message}
                            </p>
                          </div>
                          <p
                            className={`${
                              item.tag == "Sender" ? "text-right" : "text-left"
                            } text-xs w-full`}
                          >
                            {formatDateForInput(item?.date)}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>
                <div
                  className={`flex flex-row font-pop justify-between items-center  rounded-3xl py-2 px-4
                             ${
                               theme == "dark"
                                 ? "bg-black text-white"
                                 : "bg-[#E8E8E8] "
                             } `}
                >
                  <div className="flex w-[100%] flex-row items-center gap-2">
                    <label
                      htmlFor="fileupload"
                      className="relative cursor-pointer"
                    >
                      <img
                        src="../../Assets/Prop/docattach.png"
                        alt="Upload"
                        className="w-8 h-8"
                      />
                      <input
                        type="file"
                        id="fileupload"
                        className="hidden"
                        onChange={FileUpload}
                      />
                    </label>

                    <div className="flex gap-2 w-full">
                      {UploadedFile !== "" && UploadedFile !== null && (
                        <div
                          className={` p-2 rounded shadow-md font-pop flex items-center
                                             ${
                                               theme == "dark"
                                                 ? "bg-black text-white"
                                                 : "bg-gray-300 "
                                             } `}
                        >
                          <div className="flex flex-col gap-2">
                            {ChatFile && renderFileIcon(ChatFile)}
                            <span className="ml-2 w-max text-xs">
                              {FileName}
                            </span>
                          </div>

                          <FaTimes
                            className="ml-2 text-red-500 cursor-pointer"
                            onClick={() => {
                              setChatFile(null);
                              setFileName(null);
                              setUploadedFile(null);
                            }}
                          />
                        </div>
                      )}
                      <input
                        type="text"
                        value={message}
                        onChange={(e) => {
                          setmessage(e.target.value);
                        }}
                        placeholder="Message..."
                        onKeyDown={handleKeyDown}
                        className="text-lg w-[100%] font-normal border-transparent outline-none focus:outline-none focus:border-transparent active:border-transparent active:outline-none bg-transparent"
                      />
                    </div>
                  </div>
                  <img
                    src="./../../../Assets/Prop/messagesend.png"
                    alt="message send"
                    onClick={handleSendMessage}
                    className="w-8 h-8 cursor-pointer"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MainChat;
